import * as React from 'react';
import makeIcon from './make_icon';
import { jsx as ___EmotionJSX } from "@emotion/core";
var roundFilled = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 3.5C8 3.22386 7.77614 3 7.5 3C7.22386 3 7 3.22386 7 3.5V5V6.5C7 6.77614 7.22386 7 7.5 7C7.77614 7 8 6.77614 8 6.5V5.5H14.5C14.7761 5.5 15 5.27614 15 5C15 4.72386 14.7761 4.5 14.5 4.5H8V3.5ZM17 3.5C17 3.22386 16.7761 3 16.5 3C16.2239 3 16 3.22386 16 3.5V5V6.5C16 6.77614 16.2239 7 16.5 7C16.7761 7 17 6.77614 17 6.5V5.5H19C19.5523 5.5 20 5.94772 20 6.5V9H4V6.5C4 5.94772 4.44772 5.5 5 5.5H5.5C5.77614 5.5 6 5.27614 6 5C6 4.72386 5.77614 4.5 5.5 4.5H5C3.89543 4.5 3 5.39543 3 6.5V9.5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V9.5V6.5C21 5.39543 20.1046 4.5 19 4.5H17V3.5Z"
});
var roundLined = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5 3C7.77614 3 8 3.22386 8 3.5V4.5H14.5C14.7761 4.5 15 4.72386 15 5C15 5.27614 14.7761 5.5 14.5 5.5H8V6.5C8 6.77614 7.77614 7 7.5 7C7.22386 7 7 6.77614 7 6.5V3.5C7 3.22386 7.22386 3 7.5 3ZM16.5 3C16.7761 3 17 3.22386 17 3.5V4.5H19C20.1045 4.5 21 5.39542 21 6.5V19C21 20.1045 20.1045 21 19 21H5C3.89542 21 3 20.1045 3 19V6.5C3 5.39543 3.89543 4.5 5 4.5H5.5C5.77614 4.5 6 4.72386 6 5C6 5.27614 5.77614 5.5 5.5 5.5H5C4.44771 5.5 4 5.94771 4 6.5V9H20V6.5C20 5.94772 19.5523 5.5 19 5.5H17V6.5C17 6.77614 16.7761 7 16.5 7C16.2239 7 16 6.77614 16 6.5V3.5C16 3.22386 16.2239 3 16.5 3ZM20 10H4V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V10Z"
});
var sharpFilled = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 3.5V3H7V3.5V5V6.5V7H8V6.5V5.5H14.5H15V4.5H14.5H8V3.5ZM17 3.5V3H16V3.5V5V6.5V7H17V6.5V5.5H20V9H4V5.5H5.5H6V4.5H5.5H3.5H3V5V9.5V20.5V21H3.5H20.5H21V20.5V9.5V5V4.5H20.5H17V3.5Z"
});
var sharpLined = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 3V4.5H15V5.5H8V7H7V3H8ZM17 3V4.5H21V21H3V4.5H6V5.5H4V9H20V5.5H17V7H16V3H17ZM20 10H4V20H20V10Z"
});
var IconCalendar = makeIcon('IconCalendar', 'Calendar', false, {
  roundFilled,
  roundLined,
  sharpFilled,
  sharpLined
});
export default IconCalendar;